import { Navigate, Outlet } from "react-router-dom";
import getRole from "../_components/hooks/getRole";

const PublicRoutesOutlet = () => {
  const auth = { token: localStorage.getItem('access_token_AS') };
  const role = getRole();
  return !auth.token ? (
    <div className="w-full min-h-full h-full">
      <Outlet />
    </div>
  ) : (
    <Navigate to="/" />
  );
};

export default PublicRoutesOutlet;
